import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchTemplates({ packing_house_id, packing_house_process_id, harvested_batch_id }) {
    return RequesterV1.get(
      `packing_house/quality_control/process/list_templates/${packing_house_id}/${packing_house_process_id}/${harvested_batch_id}`
    );
  },
  fetchPackingHouseProcess({ packing_house_id, packing_house_process_id, harvested_batch_id }) {
    return RequesterV1.get(
      `packing_house/quality_control/process/list_templates/packing_house_process/${packing_house_id}/${packing_house_process_id}/${harvested_batch_id}`
    );
  },
  fetchHarvestedBatch({ packing_house_id, packing_house_process_id, harvested_batch_id }) {
    return RequesterV1.get(
      `packing_house/quality_control/process/list_templates/harvested_batch/${packing_house_id}/${packing_house_process_id}/${harvested_batch_id}`
    );
  },
};
